import { AxiosPromise } from 'axios';
import { urlsConfig } from 'src/configs';
import { queryTypes, servicesEmirTypes } from 'src/types';
import { urlHelper } from 'src/app/helpers';
import { axios, axiosc } from 'src/app/utils';

export const emirLookup = ({
  limit,
  offset,
  search,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
}: servicesEmirTypes.EmirLookupDataType): AxiosPromise<servicesEmirTypes.EmirLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (search) {
    query.search = search.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axiosc.get(urlHelper.addQueryParameters(query, urlsConfig.generics.common.emir), {
    blockSpinner,
  });
};

export const emirGruplariLookup = ({
  limit,
  offset,
  search,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
}: servicesEmirTypes.EmirLookupDataType): AxiosPromise<servicesEmirTypes.EmirGruplariLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (search) {
    query.search = search.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axiosc.get(urlHelper.addQueryParameters(query, urlsConfig.generics.common.emirGruplari), {
    blockSpinner,
  });
};

export const emirCreate = (
  form: servicesEmirTypes.EmirCreateDataType,
): AxiosPromise<servicesEmirTypes.EmirCreateResultType> => {
  return axiosc.post(urlsConfig.generics.common.emir, form, { blockErrorHandler: true });
};

export const emirEdit = (
  form: servicesEmirTypes.EmirEditDataType,
): AxiosPromise<servicesEmirTypes.EmirEditResultType> => {
  return axiosc.patch(urlsConfig.generics.common.emir, form, { blockErrorHandler: true });
};

export const emirDelete = ({
  id,
}: servicesEmirTypes.EmirDeleteDataType): AxiosPromise<servicesEmirTypes.EmirDeleteResultType> => {
  return axiosc.delete(`${urlsConfig.generics.common.emir}/${id}`);
};
